export default __webpack_public_path__ + "static/media/011-boat.0da3d194.png";